import { useState } from 'react'
import { Box } from '../widgets'
import { CitySearch, CountryDropDown } from './'

export const Location = ({ country, dark }) => {
  const [selectedCountry, setSelectedCountry] = useState(country?.toLowerCase() || '')
  const [validation, setValidation] = useState(true)

  return <Box gap={8}>
    <CountryDropDown
      name="country"
      title="Country"
      search
      required
      fullWidth
      id="country"
      onChange={value => setSelectedCountry(value?.toLowerCase() || '')}
      dark={dark}
    />
    <CitySearch
      name="city"
      title="City"
      required
      fullWidth
      country={selectedCountry}
      dark={dark}
      getValidationMessage={city => (city === undefined || !validation) && 'Please search and select an option'}
      onValidationChange={value => setValidation(value)}
    />
  </Box>
}